<script>
// 选择工程师

import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { getEngineer } from "@/helpers/common-service";
import _ from "lodash";

export default {
  props: {
    // 已选择的工程师
    value: {
      type: [Number, String],
      default: null
    },
    companyId: {
      type: Number,
      default: null
    },
    excludeEngineerId: {
      type: Number,
      default: 0
    },
    // value字段，默认是id
    valueField: {
      type: String,
      default: 'id'
    },
    // 返回字段，默认返回id，如果要返回完整的工程师对象，传obj
    returnField: {
      type: String,
      default: 'id'
    },
    // 只有当有company时才查询数据
    getDataWhenHasCompany: {
      type: Boolean,
      default: true
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    placeholoderText: {
      type: String,
      default: ''
    },
    unbindAccount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enginerrId: null,
      engineer: [],
    }
  },
  computed: {
    availableEngineer() {
      if (this.excludeEngineerId) {
        return _.filter(this.engineer, o => o.id != this.excludeEngineerId)
      }
      return this.engineer
    }
  },
  methods: {
    getEngineer(companyId) {
      this.engineer = []
      if (this.getDataWhenHasCompany && !companyId) {
        return
      }
      getEngineer(companyId, this.unbindAccount).then(res => {
        this.engineer = res
      })
    },
    changeEngineer(value) {
      if (this.returnField === 'id') {
        this.$emit('changed', value)
      }
      if (this.returnField === 'obj') {
        // 返回工程师对象
        const currentEngineer = _.find(this.engineer, ['id', value])
        this.$emit('changed', _.cloneDeep(currentEngineer))
      }
    }
  },
  components: {
    Multiselect,
  },
  watch: {
    companyId: {
      immediate: true,
      handler(val) {
        this.getEngineer(val)
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (this.valueField === 'id') {
          this.enginerrId = val
        }
      }
    }
  }
}
</script>
<template>
  <Multiselect
      class="form-control"
      :class="isInvalid ? 'is-invalid' : ''"
      :can-clear="false"
      :can-deselect="false"
      v-model="enginerrId"
      :close-on-select="true"
      :searchable="true"
      :create-option="false"
      value-prop="id"
      label="name"
      :placeholder="placeholoderText"
      :disabled="isDisabled"
      :options="availableEngineer"
      @change="changeEngineer"
  />
</template>
